module.exports = __webpack_public_path__ + "img/코엑스 소고기.852e1ca3.png";